<template>
    <Header />
    <div class="w-full font-basic pt-20">
        <Motion
            :initial="{ opacity: 1 }"
        >
            <Motion
                v-for="(section, index) in sections"
                :key="index"
                :initial="motionConfig.initial"
                :while-in-view="motionConfig.whileInView"
                :transition="motionConfig.transition"
                :inViewOptions="motionConfig.inViewOptions"
            >
                <component :is="section.component" v-bind="section.props" @scroll-to-contact="scrollToTarget('contact-us')" />
            </Motion>
        </Motion>

        <Footer />
    </div>
</template>

<script>
import Header from '@/components/layoutComponents/Header.vue'
import Footer from '@/components/layoutComponents/Footer.vue'
import TestingServiceHero from '@/components/sw/TestingServiceHero.vue'
import TextBanner from '@/components/sw/TextBanner.vue'
import PortfolioCarousel from '@/components/sw/PortfolioCarousel.vue'
import CustomerReviewSection from '@/components/sw/CustomerReviewSection.vue'
import OutsourcingProcess from '@/components/sw/OutsourcingProcess.vue'
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import DevelopmentScope from '@/components/sw/DevelopmentScope.vue'
import QnaV2 from '@/components/sw/QnaV2.vue'
import { Motion, stagger } from 'motion-v'

export default {
    components: {
        Header,
        Footer,
        TestingServiceHero,
        TextBanner,
        PortfolioCarousel,
        CustomerReviewSection,
        OutsourcingProcess,
        DevelopmentScope,
        QnaV2,
        Motion,
    },

    data() {
        return {
            projectCnt: 0,
            motionConfig: {
                initial: { opacity: 0, y: 20 },
                whileInView: { opacity: 1, y: 0 },
                transition: {
                    ease: 'easeOut',
                    duration: 0.5,
                },
                inViewOptions: {
                    once: true,
                }
            },
            sections: [
                { component: 'TestingServiceHero', props: {} },
                { component: 'TextBanner', props: {} },
                { component: 'PortfolioCarousel', props: {} },
                { component: 'CustomerReviewSection', props: {} },
                { component: 'DevelopmentScope', props: {} },
                {
                    component: 'OutsourcingProcess',
                    props: { class: 'new_lg:max-w-7xl w-full overflow-hidden mx-auto' }
                },
                {
                    component: 'QnaV2',
                    props: {
                        propPlatform: '2',
                        title: '개발 서비스',
                        description: '고객 맞춤 컨설팅을 제공합니다.',
                    }
                },
            ]
        }
    },

    mounted() {
        window.scrollTo(0, 0);
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }

        gtag('event', 'conversion', {
            'send_to': 'AW-16592420747/JL1eCLr59Y4aEIv_8Oc9',
            'value': 10.0,
            'currency': 'KRW'
        });

        gsap.registerPlugin(ScrollTrigger);
        gsap.to(this.$data, {
            projectCnt: 130,
            duration: 10,
            scrollTrigger: {
                trigger: ".scrolltrigger",
                start: "top center bottom",
                toggleActions: "play none none none",
                onEnter: () => {
                    // this.projectCnt = 0; // 스크롤 트리거가 시작되면 숫자를 0으로 초기화
                }
            },
            onUpdate: () => {
                this.projectCnt = Math.round(this.projectCnt);
            }
        });

        if (typeof gtag === 'function') {
            console.log('gtag call');
            gtag('event', 'conversion', {
                send_to: 'AW-16592420747/JL1eCLr59Y4aEIv_8Oc9',
                value: 1.0,
                currency: 'KRW',
            });
        } else {
            console.error('gtag is not defined. Ensure the gtag script is loaded in index.html.');
        }
    },

    methods: {
        stagger,
        scrollToTarget(targetId) {
            this.$nextTick(() => {
                const targetElement = document.getElementById(targetId);
                if (!targetElement) return;

                const offset = 100;
                const isMobile = window.innerWidth <= 768;

                let scrollContainer = document.documentElement;

                let parent = targetElement.parentElement;
                while (parent && parent !== document.body) {
                    if (parent.scrollHeight > parent.clientHeight) {
                        scrollContainer = parent;
                        break;
                    }
                    parent = parent.parentElement;
                }

                let yPosition = 0;

                if(isMobile) {
                    if(targetId === '3s-three-system')
                        yPosition = 2050;
                    else if(targetId === 'contact-us')
                        yPosition = 4900;
                } else {
                    yPosition =
                    targetElement.getBoundingClientRect().top +
                    scrollContainer.scrollTop -
                    offset;
                }

                scrollContainer.scrollTo({
                    top: yPosition,
                    behavior: "smooth",
                });
            });
        },
        goToPage(path) {
            this.$router.push(path)
        },
    },
}
</script>

<style scoped>
[target] {
    scroll-margin-top: 180px;
}
</style>
